
import Vue from 'vue';
import VueMask from 'v-mask';
import { BootstrapVue } from 'bootstrap-vue';
import { setupVeeValidate } from './setup-vee-validate';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleArrowDown, faArrowLeft, faPenToSquare, faBan, faUpRightAndDownLeftFromCenter, faX,
  faPrint, faSquarePen, faCreditCardAlt, faUserCircle, faMoneyBill, faBullhorn, faBarcode, faLock, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

export const setupVue = () => {
  Vue.use(BootstrapVue);
  Vue.use(VueMask);
  setupVeeValidate();
  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('ValidationObserver', ValidationObserver);
  library.add([faBarcode, faBullhorn, faUserCircle, faMoneyBill, faCircleArrowDown, faArrowLeft, faPenToSquare, faBan, faUpRightAndDownLeftFromCenter, faX, faPrint, faSquarePen, faCreditCardAlt, faLock, faXmark]);
  Vue.component('font-awesome-icon', FontAwesomeIcon);


  Vue.config.productionTip = true;
};
